import { Box, IconButton, Switch, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { CustomDataGrid } from '../../../common/components/Table/CustomDataGrid';
import ContainedButton from '../../../common/components/Buttons/ContainedButton';
import httpCommon from '../../../http-common';
import CustomExportButton from '../../../common/components/Table/CustomExportButton';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { FileUploaderRipik } from '../../HomePage/components/FileUploaderRipik';
import SnackbarWithMessage from '../../../common/components/Snackbars/SnackbarWithMessage';
import { mixpanelTrackTabsButton } from '../../../mixPanelFunctions/mixPanelFunctions';


const postAnalyst = async (analyst_id) => {
  const data = JSON.stringify({ analyst_id });
  try {
    const response = await httpCommon.post(`/v1/qc/test_to_analyst`, data);
    const result = response.data;
    if (result?.status === "success") return true;
    else throw new Error(`Analyst couldn't be added, response message:${result.message}`);
  } catch (error) {
    console.log({ error });
    return false;
  }
};

const deleteAnalyst = async (analyst_id) => {
  const data = JSON.stringify({ analyst_id });
  try {
    const response = await httpCommon.delete(`/v1/qc/test_to_analyst`, { data });
    const result = response.data;
    if (result?.status === "success") return true;
    else throw new Error(`Analyst couldn't be deleted, response message:${result.message}`);
  } catch (error) {
    console.log({ error });
    return false;
  }
};

const TestToAnalyst = () => {
  const apiRef = useGridApiRef();

  const [columns, set_columns] = useState([]);

  const [data, setData] = useState([]);
  const [newData, setNewData] = useState({
    analyst_id: '',
    // Add other column keys here with default values if needed
  });

  const initialize_columns = async (allKeys) => {
    const uniqueKeys = Array.from(new Set(allKeys));

    console.log({ allKeys, uniqueKeys });
    const skill_mapping_response = await httpCommon.get(`v1/qc/get_skill_mapping`);

    const skill_mapping_result = await skill_mapping_response.data;

    const headers = uniqueKeys.map((key) => {
      if (key === "analyst_id") return {
        field: key,
        headerName: "Analyst ID",
      };
      return {
        field: key,
        headerName: key,
        renderCell: (params) => {
          // console.log(params);
          return (
            <div style={{ color: getColorBySkill(params.value) }}>
              {params.formattedValue}
            </div>
          );
        },
        width: "175",
        editable: true,
        type: "singleSelect",
        valueOptions: [...skill_mapping_result.data]
      };
    });

    headers.push(
      {
        field: 'is_disabled',
        headerName: 'Enable',
        width: 100,
        renderCell: (params) => {
          // console.log({ params });
          return (
            <div style={{ position: 'sticky', right: 0, zIndex: 1 }}>
              <Switch checked={!params?.row?.is_disabled} onClick={() => {
                handleDeleteAnalyst(params);
              }} />
              {/* <IconButton>
                <DeleteIcon style={{ color: '#ff5722' }} />
              </IconButton> */}
            </div>
          );
        },
      },
    );

    set_columns(headers);
  };

  const fetchData = async () => {
    try {
      const response = await httpCommon.get(`/v1/qc/test_to_analyst`);
      const dummyData = response.data.data.filter(item => item.analyst_id !== null).map(item => ({
        ...item,
        id: item._id
      }));
      console.log(dummyData);
      const first_object = dummyData[0];
      const { _id, analyst_id, id, ...tests } = first_object;
      const test_names = Object.keys(tests);
      const allKeys = ["analyst_id", ...test_names];
      initialize_columns(allKeys);

      setData(dummyData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleDeleteAnalyst = async (params) => {
    // console.log({ params });
    const response = await deleteAnalyst(params.row.analyst_id);
    if (response === true) {
      const row_id = params.row.id;
      apiRef.current.updateRows([{
        id: row_id,
        is_disabled: !params?.row?.is_disabled
      }]);
    }
    else {
      console.log("probably this analyst doesn't exist, reloading the data for you.");
      fetchData();
    }
  };


  useEffect(() => {
    // Simulate fetching data from APIs (using a Promise)


    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const fetchDummyData = () => {
  //   // Simulate API call using a Promise
  //   return new Promise((resolve) => {
  //     // Replace this with your actual dummy data or data generation logic
  //     const dummyData = generateDummyData();
  //     setTimeout(() => {
  //       resolve(dummyData);
  //     }, 1000); // Simulate a 1-second delay
  //   });
  // };

  const getColorBySkill = (skill) => {
    if (skill === 'H') return 'green';
    if (skill === 'C') return 'green';
    if (skill === 'M') return 'orange';;
    return 'red';
  };

  const handleNewDataChange = (event) => {
    const { name, value } = event.target;
    setNewData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAddNewData = async () => {
    const analyst_id = newData.analyst_id;
    const result = await postAnalyst(analyst_id);
    if (result === true) {
      setData((prevData) => [{ ...newData, id: newData.analyst_id }, ...prevData]);
      setNewData({
        analyst_id: '',
        // Reset other column values if needed
      });
      mixpanelTrackTabsButton("TestToAnalyst","add analyst","master-sheet") // tracking tab button
      console.log("analyst added:", analyst_id);
    }
    else {
      console.log("analyst couldn't be added.");
    }
  };

  useEffect(() => {
    console.log({ columns });
  }, [columns]);

  // const columns = generateColumns();

  const saveOnServer = async (updatedRow) => {
    const { _id, analyst_id, ...update_fields } = updatedRow;

    const data = JSON.stringify({
      analyst_id,
      update_fields
    });
    const response = await httpCommon.patch(`/v1/qc/test_to_analyst`, data);
    const result = response.data.status;
    if (result === "success") return true;
    else return false;
  };

  const [open_snackbar_with_message, set_open_snackbar_with_message] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const [file, set_file] = useState(null);

  const handle_file_upload = async (uploaded_file) => {
    try {
      const data = new FormData();
      data.append("excel_file", uploaded_file);
      // console.log([...data.entries()]);
      const response = await httpCommon.post(`/v1/qc/upload_mastersheet/test_to_analyst/`, data, {
        "headers": {
          "Content-Type": "multipart/form-data"
        }
      });
      const result = response.data;
      console.log({ result });
      mixpanelTrackTabsButton("TestToAnalyst","file upload","master-sheet") // tracking tab button
      if (result.status === "error") {
        set_open_snackbar_with_message({
          message: result.message,
          open: true,
          severity: "error"
        });
      }
      else if (result.status === "success") {
        set_open_snackbar_with_message({
          message: `Data uploaded successfully!`,
          open: true,
          severity: "success"
        });
        fetchData();
      }
    } catch (error) {
      console.log({ error });
    }
  };


  return (
    <div>
      {/* <Box>
      </Box> */}
      <Box>
        <SnackbarWithMessage {...open_snackbar_with_message} onClose={() => {
          set_open_snackbar_with_message({
            open: false,
            message: "",
            severity: "info"
          });
        }} />
        <Box className="flex justify-end items-center">
          <FileUploaderRipik file={file} file_update_function={(uploaded_file) => {
            set_file(uploaded_file);
            console.log(uploaded_file);
            handle_file_upload(uploaded_file);
          }} upload_message={`Upload File Here`} />
        </Box>
        <CustomDataGrid
          apiRef={apiRef}
          rows={data}
          columns={columns}
          disableRowSelectionOnClick
          initialState={{
            pinnedColumns: {
              left: ["analyst_id"],
              right: ["is_disabled"]
            }
          }}
          processRowUpdate={async (updatedRow, originalRow) => {
            const result = await saveOnServer(updatedRow);
            if (result) return updatedRow;
            else return originalRow;
            // console.log({ updatedRow, originalRow });
            // return updatedRow;
          }
          }
          sx={{
            height: "500px"
          }}
          hideFooter
          slots={{
            toolbar: CustomExportButton
          }}
        // hideFooter
        // ... other props
        />
      </Box>
      <Box mt={2} className="">
        <Typography variant="h6">Add New Analyst</Typography>
        <Box className="flex items-center gap-2">
          <TextField
            name="analyst_id"
            label="Analyst ID"
            value={newData.analyst_id}
            onChange={handleNewDataChange}
            variant="outlined"
            margin="dense"
          />
          {/* Add other TextField components for additional columns */}

          <ContainedButton variant="contained" color="primary" onClick={handleAddNewData}>
            Add Analyst
          </ContainedButton>
        </Box>
      </Box>
    </div>
  );
};

export default TestToAnalyst;